module.exports = __webpack_public_path__ + "static/media/forgotpassword_bg2.574a1164.jpg";